"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var formatting_1 = require("./utils/formatting");
var lists_1 = require("./lists");
/**
 * Returns the value with '' around it.  Any 's will be escaped \' in the output
 */
function border(p) {
    return lists_1.params(p.color, p.style, formatting_1.ensureLength(p.width));
}
exports.border = border;
exports.borderColor = lists_1.params;
exports.borderStyle = lists_1.params;
exports.borderWidth = lists_1.params;
